import {useUnityContext} from "react-unity-webgl"

let unityContext = null;
function UnityContext() {
    unityContext = useUnityContext({
        // loaderUrl: "/Build/v1.7.loader.js",
        // dataUrl: "/Build/v1.7.data",
        // frameworkUrl: "/Build/v1.7.framework.js",
        // codeUrl: "/Build/v1.7.wasm",
        //loaderUrl: "/jsonLoader/v1.1.loader.js",
        //dataUrl: "/jsonLoader/v1.1.data",
        //frameworkUrl: "/jsonLoader/v1.1.framework.js",
        //codeUrl: "/jsonLoader/v1.1.wasm",
        loaderUrl: "/Build/Illusmaker/Build/build.loader.js",
        dataUrl: "/Build/Illusmaker/Build/build.data",
        frameworkUrl: "/Build/Illusmaker/Build/build.framework.js",
        codeUrl: "/Build/Illusmaker/Build/build.wasm",
        companyName: "HSRW",
        productName: "StreenIllusMaker",
        productVersion: "1.0",
        graphicsAPI: ["WebGL 2.0", "WebGL 1.0"],
      });
      
    
      return unityContext;
}

const logMemoryUsage = (label) => {
    if (performance.memory) {
        console.log(`${label} - Used Memory: `, performance.memory.usedJSHeapSize);
        
        console.log(`${label} - Memory Usage: `, {
        UsedJSHeap:
          (performance.memory.usedJSHeapSize / 1024 / 1024).toFixed(2) + " MB",
        TotalJSHeap:
          (performance.memory.totalJSHeapSize / 1024 / 1024).toFixed(2) + " MB",
        JSHeapLimit:
          (performance.memory.jsHeapSizeLimit / 1024 / 1024).toFixed(2) + " MB",
      });
      if ((performance.memory.usedJSHeapSize / 1024 / 1024).toFixed(2) > 1000){
        window.gc();
      }
    } else {
      console.warn("Memory API not supported in this browser.");
    }
  };
async function unloadUnityWebGL() {
    
    const { loadingProgression, unload, UNSAFE__unityInstance } = unityContext;
    // Unity context setup
  
    try {
      if (Math.round(loadingProgression * 100) < 100) {
        console.warn("🛑 Unity is still loading. Unload skipped.");
        return;
      }
  
      logMemoryUsage("🔍 Memory usage before cleanup:");
  
      // Unload Unity
      if (unload) {
        await unload();
        console.log("✅ Unity unloaded");
      }
  
      // Destroy WebGL context
      const canvas = document.querySelector("canvas");
      if (canvas) {
        const gl = canvas.getContext("webgl2") || canvas.getContext("webgl");
        if (gl) {
          gl.getExtension("WEBGL_lose_context")?.loseContext();
          console.log("🧹 WebGL context lost");
        }
      }
     
      // Force GC if available
      if (typeof window.gc() === "function") {
        window.gc();
        console.log("🗑️ Manual GC triggered");
      }
  
      setTimeout(() => {
        logMemoryUsage("🔍 Memory usage after cleanup:");
        
        }, 5000); // Check memory after 5s*/
        console.log("🗑️ Removing from memory");
        UNSAFE__unityInstance.Quit();
        // window.gc();

        
    } catch (error) {
      console.error("❌ Error during Unity shutdown:", error);
      window.location.reload(); // Fallback
    }
  }

export {UnityContext, unloadUnityWebGL, unityContext};